export const groupsAll = [
  {
    label: 'Общие',
    options: [
      {value: 'manager', label: 'Менеджер'},
      {value: 'deposit', label: 'Депозит'},
      {value: 'traffic_source', label: 'Источник'},
    ],
  },
  {
    label: 'Телеграм',
    options: [
      {value: 'bot', label: 'Бот'},
      {value: 'channel', label: 'Канал'},
      {value: 'tg_account', label: 'Телеграм Аккаунт'},
    ],
  },
  {
    label: 'Отдел продаж',
    options: [
      // {value: 'team', label: 'Команда'},
      {value: 'manager', label: 'Менеджер'},
    ],
  },
  {
    label: 'Influence',
    options: [
      {value: 'inf_traffic', label: 'Блогер'},
      {value: 'inf_source', label: 'INF Поток'},
      {value: 'inf_bayer', label: 'INF Байер'},
    ],
  },
  {
    label: 'Facebook',
    options: [
      {value: 'fb_traffic', label: 'FB Кампания'},
      {value: 'fb_source', label: 'FB Поток'},
      {value: 'pixel', label: 'Пиксель'},
      {value: 'fb_bayer', label: 'FB Байер'},
    ],
  },
  {
    label: 'Партнеры',
    options: [
      {value: 'advertiser', label: 'Рекламодатель'},
      {value: 'brand', label: 'Бренд'},
      {value: 'country', label: 'Гео'},
      {value: 'offer', label: 'Оффер'},
      {value: 'landing', label: 'Лендинг'},
    ],
  },
];

export const groupsHeadOfSales = [
  {
    label: 'Общие',
    options: [
      {value: 'manager', label: 'Менеджер'},
      {value: 'traffic_source', label: 'Источник'},
    ],
  },
  {
    label: 'Телеграм',
    options: [
      {value: 'bot', label: 'Бот'},
      {value: 'channel', label: 'Канал'},
      {value: 'tg_account', label: 'Телеграм Аккаунт'},
    ],
  },
  {
    label: 'Отдел продаж',
    options: [{value: 'manager', label: 'Менеджер'}],
  },
  {
    label: 'Influence',
    options: [
      {value: 'inf_traffic', label: 'Блогер'},
      {value: 'inf_bayer', label: 'INF Байер'},
    ],
  },
  {
    label: 'Facebook',
    options: [
      {value: 'fb_traffic', label: 'FB Кампания'},
      {value: 'fb_bayer', label: 'FB Байер'},
    ],
  },
  {
    label: 'Партнеры',
    options: [
      {value: 'brand', label: 'Бренд'},
      {value: 'country', label: 'Гео'},
    ],
  },
];

export const groupsTeamleader = [
  {
    label: 'Общие',
    options: [
      {value: 'traffic_source', label: 'Источник'},
    ],
  },
  {
    label: 'Отдел продаж',
    options: [{value: 'manager', label: 'Менеджер'}],
  },
  {
    label: 'Партнеры',
    options: [
      {value: 'brand', label: 'Бренд'},
      {value: 'country', label: 'Гео'},
    ],
  },
];

export const groupsManager = [
  {
    label: 'Общие',
    options: [{value: 'traffic_source', label: 'Источник'}],
  },
  {
    label: 'Телеграм',
    options: [
      {value: 'bot', label: 'Бот'},
      {value: 'channel', label: 'Канал'},
      {value: 'tg_account', label: 'Телеграм Аккаунт'},
    ],
  },
  {
    label: 'Партнеры',
    options: [
      {value: 'brand', label: 'Бренд'},
      {value: 'country', label: 'Гео'},
    ],
  },
];
